module.exports = __webpack_public_path__ + "media/img/savings-illustration-cded284c12feccaa0ffdfcfbaca64bbd.png";